'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    BackgroundAppearanceContext: function() {
        return BackgroundAppearanceContext;
    },
    BackgroundAppearanceProvider: function() {
        return BackgroundAppearanceProvider;
    },
    useBackgroundAppearance: function() {
        return useBackgroundAppearance;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const BackgroundAppearanceContext = _react.createContext(undefined);
const BackgroundAppearanceProvider = BackgroundAppearanceContext.Provider;
function useBackgroundAppearance() {
    return _react.useContext(BackgroundAppearanceContext);
}
